__turbopack_context__.v({
  "chartTheme": "articles-activity-heatmap-module__t3hNoq__chartTheme",
});
